import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ebeihilfe-note',
  imports: [CommonModule, MatIconModule],
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
})
export class NoteComponent {
  public messageText = input.required<string>();
  public type = input.required<'success' | 'danger' | 'warning' | 'info'>();
  public icon = computed(() => {
    switch (this.type()) {
      case 'success':
        return 'check_circle';
      case 'danger':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  });
}
